"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TableWidgetContext_1 = require("./TableWidgetContext");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = __importDefault(require("lodash"));
var RepeatingTableRow_1 = require("Project/QwilrEditor/Widgets/TableWidget/RepeatingTableRow");
var getCellIndex = function (columns, rowNumber, columnNumber) {
    return rowNumber * columns + columnNumber;
};
var TableCell = function (_a) {
    var _b;
    var attributes = _a.attributes, children = _a.children, element = _a.element, widgetManager = _a.widgetManager;
    var ref = attributes.ref;
    var _c = (0, react_1.useContext)(TableWidgetContext_1.TableWidgetContext), hasSelectedCells = _c.hasSelectedCells, selection = _c.selection, tableSelectionManager = _c.tableSelectionManager, data = _c.data, cellsAreEditable = _c.cellsAreEditable;
    var repeatingRowMenu = (_b = (0, react_1.useContext)(RepeatingTableRow_1.RepeatingTableRowContext)) === null || _b === void 0 ? void 0 : _b.repeatingRowMenu;
    var cellPath = widgetManager.getPath(element);
    var columns = data.columns;
    var cellNumber = lodash_1.default.last(cellPath);
    var rowNumber = lodash_1.default.nth(cellPath, -2) - 1;
    var cellIndex = getCellIndex(columns, rowNumber, cellNumber);
    (0, react_1.useEffect)(function () {
        if (ref.current) {
            tableSelectionManager.setCellElem(cellIndex, ref.current);
        }
        return function () {
            tableSelectionManager.clearCellElem(ref.current);
        };
    }, [cellIndex, ref.current]);
    var markCellAsSelected = hasSelectedCells &&
        !tableSelectionManager.areAllCellsSelected() &&
        selection.selectedCells &&
        selection.selectedCells[cellIndex];
    var potentiallyRenderRepeatingRowMenu = function () {
        if (repeatingRowMenu && cellNumber === 0) {
            return repeatingRowMenu;
        }
    };
    return (react_1.default.createElement("td", __assign({}, attributes, { className: (0, classnames_1.default)("table-widget__cell", {
            "table-widget__cell--selected": markCellAsSelected,
        }), contentEditable: cellsAreEditable, suppressContentEditableWarning: true }),
        potentiallyRenderRepeatingRowMenu(),
        children));
};
exports.default = TableCell;
